<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col cols="12">
          <h3 class="ml-1 mb-2">
            الفلاتر
          </h3>
        </b-col>
        <!-- <b-col cols="4" v-if="status_data">
          <v-select
            v-model="filter.status"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="status_data"
            class="w-100 mb-0"
            :reduce="(val) => val"
            placeholder="User Status"
            :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
          >
            <template v-slot:option="option">
              {{ $i18n.locale == "ar" ? option.name_local : option.name }}
            </template>
            <template #selected-option="{ name, name_local }">
              <div style="display: flex; align-items: baseline">
                <strong v-if="$i18n.locale == 'ar'">{{ name_local }} </strong>
                <strong v-else>{{ name }} </strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col> -->
        <b-col cols="4">
          <b-form-input
            v-model="filter.search"
            placeholder="Search name or email"
          />
        </b-col>
        <b-col cols="4">
          <v-select
            v-model="filter.type"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="type_data"
            class="w-100 mb-0"
            :reduce="(val) => val.value"
            placeholder="Type"
          />
        </b-col>
      </b-row>

    </b-card>
    <b-card class="w-100 d-flex rounded-lg">
      <b-row>
        <b-col
          md="12"
          class="pb-2 w-100 d-flex justify-content-between"
        >
          <h3 class="ml-1 mb-2">
            الموظفين
          </h3>
          <div class="d-flex">
            <b-link
              v-if="hasPermission('create employees')"
              class="btn btn-success rounded-pill pt-1 mr-2"
              to="add_outer_employee"
            >
              اضافة موظف خارجي
            </b-link>
            <b-link
              v-if="hasPermission('create users')"
              class="btn btn-primary rounded-pill pt-1"
              to="add_employee"
            >
              موظف جديد
            </b-link>
          </div>
        </b-col>
      </b-row>

      <center v-if="load">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <div v-else>
        <b-table
          :items="items.data"
          :fields="fields"
          striped
          responsive
        >
          <template #filter />
          <template #cell(show_details)="row">
            <b-form-checkbox
              v-model="row.detailsShowing"
              plain
              class="vs-checkbox-con"
              @change="row.toggleDetails"
            >
              <span class="vs-checkbox">
                <span class="vs-checkbox--check">
                  <i class="vs-icon feather icon-check" />
                </span>
              </span>
              <span class="vs-label">{{
                row.detailsShowing ? "Hide" : "Show"
              }}</span>
            </b-form-checkbox>
          </template>

          <template #row-details="row">
            <b-card>
              <div class="mb-1">
                <strong>أرصدة المحافظ</strong>
                <div
                  v-if="!(row.item.wallets && row.item.wallets.length)"
                  class="text-muted"
                >
                  لا توجد محفظة عهدة
                </div>
                <div
                  v-for="wallet in row.item.wallets || []"
                  :key="wallet.id"
                >
                  {{ wallet.name || ('محفظة #' + wallet.id) }} — {{ formatCurrency(wallet.current_balance || 0) }}
                </div>
                <div>
                  <strong>الإجمالي</strong> {{ formatCurrency(row.item.wallet_balance || 0) }}
                </div>
              </div>
              <b-row class="mb-2">
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>Full Name : </strong>{{ row.item.full_name }}
                </b-col>
                <b-col
                  md="4"
                  class="mb-1"
                />
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>Email : </strong>{{ row.item.email }}
                </b-col>
                <b-col
                  md="4"
                  class="mb-1"
                >
                  <strong>City : </strong>{{ row.item.city }}
                </b-col>
                <b-col
                  md="4"
                  class="mb-1"
                >

                  <strong>Age : </strong>{{ row.item.age }}
                </b-col>
              </b-row>

              <b-button
                size="sm"
                variant="outline-secondary"
                @click="row.toggleDetails"
              >
                Hide Details
              </b-button>
            </b-card>
          </template>

          <template #cell(avatar)="data">
            <b-avatar :src="data.item.avatar" />
          </template>

          <template #cell(fname)="data">
            <div>
              {{ data.item.fname + " " + data.item.lname }}
            </div>
          </template>
          <template #cell(wallet_balance)="data">
            <div>
              {{ formatCurrency(data.item.wallet_balance || 0) }}
            </div>
          </template>
          <template #cell(actions)="data">
            <div class="d-flex align-items-center">

              <b-link
                v-if="hasPermission('edit employees')"
                :to="{ name: 'edit_employee', params: { id: data.item.id } }"
              >
                <feather-icon
                  icon="EditIcon"
                  class="text-info mr-1 "
                  size="20"
                />
              </b-link>
              <b-link
                v-if="hasPermission('view employees')"
                :to="{ name: 'employeeDetails', params: { id: data.item.id } }"
              >
                <feather-icon
                  icon="EyeIcon"
                  class="text-muted mr-1 "
                  size="20"
                />
              </b-link>
              <feather-icon
                icon="TrashIcon"
                class="text-danger mr-1 "
                size="20"
                @click="deleteEmployee(data.item.id)"
              />
              <b-link
                v-if="hasPermission('edit employees') && data.item.user == null"
                v-b-tooltip.hover.top="'أضافة كمستخدم'"
                @click.prevent="openAddUserModal(data.item)"
              >
                <feather-icon
                  icon="UserIcon"
                  class="text-primary mr-1 "
                  size="20"
                />
              </b-link>
            </div>

          </template>
        </b-table>

        <b-pagination
          v-model="items.meta.current_page"
          align="center"
          :total-rows="items.meta.total"
          :per-page="items.meta.per_page"
          @change="onPageChange"
        />
      </div>
    </b-card>
    <b-modal
      id="add-user-modal"
      v-model="addUserModal"
      title="إضافة كمستخدم"
      hide-footer

      no-close-on-backdrop
      hide-header-close
      centered
      @hidden="resetModal"
    >
      <b-tabs
        v-model="userModalTabIndex"
        content-class="mt-2"
      >
        <!-- Tab 1: Add New User -->
        <b-tab title="إضافة مستخدم جديد">
          <validation-observer
            ref="addUserForm"
            v-slot="{ handleSubmit }"
          >
            <b-form @submit.prevent="handleSubmit(submitAddUser)">
              <b-row>
                <b-col
                  md="6"
                  sm="12"
                  class="mt-1"
                >
                  <b-form-group
                    label="البريد الإلكتروني"
                    label-for="user_email"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="email"
                      rules="email"
                    >
                      <b-form-input
                        id="user_email"
                        v-model="addUserForm.email"
                        name="user_email"
                        autocomplete="new-email"
                        spellcheck="false"
                        autocapitalize="off"
                        autocorrect="off"
                        placeholder="أدخل البريد الإلكتروني"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  sm="12"
                  class="mt-1"
                >

                  <validation-provider
                    #default="{ errors }"
                    name="roles"
                    vid="roles"
                    rules="required"
                  >
                    <b-form-group
                      label="الادوار"
                      label-for="roles"
                    >
                      <v-select
                        v-model="addUserForm.roles"
                        multiple
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="roles"
                        :reduce="val => val.name"
                        :get-option-label="option => option.name"
                      >
                        <template #option="{ name }">
                          <span class="ml-50"> {{ name }}</span>
                        </template>

                        <template #selected-option="{ name }">
                          <span class="ml-50"> {{ name }}</span>
                        </template>
                      </v-select>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col
                  md="6"
                  sm="12"
                  class="mt-1"
                >

                  <b-form-group
                    label="كلمة المرور"
                    label-for="add-user-password"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="password"
                      rules="required|min:6"
                    >
                      <b-form-input
                        id="add-user-password"
                        v-model="addUserForm.password"
                        autocomplete="off"
                        type="password"
                        placeholder="أدخل كلمة المرور"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  sm="12"
                  class="mt-1"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="password_confirmation"
                    vid="password_confirmation"
                    rules="required|confirmed:password"
                  >
                    <b-form-group
                      label=" تأكيد الباسورد"
                      label-for="password_confirmation"
                    >
                      <b-input-group class="input-group-merge form-send-message mr-1">
                        <b-form-input
                          v-model="addUserForm.password_confirmation"
                          type="password"
                          placeholder="الباسورد"
                        />
                      </b-input-group>
                    </b-form-group>
                    <small class="text-danger float-left">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
              </b-row>

              <div class="d-flex justify-content-end mt-1">
                <b-button
                  variant="primary"
                  type="submit"
                >
                  حفظ
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="addUserModal = false"
                >
                  إلغاء
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-tab>

        <!-- Tab 2: Link to Existing User -->
        <b-tab title="ربط بمستخدم موجود">
          <div>
            <b-form-group
              label="المستخدم"
              label-for="user-search"
            >
              <v-select
                v-model="selectedUserID"
                :options="unlinkedUsers"
                :reduce="val => val.id"
                :get-option-label="option => option.name"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                placeholder="ابحث عن مستخدم"
                :filterable="false"
                :loading="linkUserLoading"
                @search="onUserSearchInput"
              >
                <template #option="{ name }">
                  <span class="ml-50"> {{ name }}</span>
                </template>
                <template #selected-option="{ name }">
                  <span class="ml-50"> {{ name }}</span>
                </template>
              </v-select>
            </b-form-group>

            <div class="d-flex justify-content-end mt-3">
              <b-button
                variant="primary"
                :disabled="!selectedUserID || linkUserLoading"
                @click="linkEmployeeToUser"
              >
                ربط الموظف
              </b-button>
              <b-button
                variant="outline-secondary"
                class="ml-1"
                @click="addUserModal = false"
              >
                إلغاء
              </b-button>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  BLink,
  VBTooltip,
  BSpinner,
  BPagination,
  BFormInput,
  BInputGroup,
  BForm,
  BFormGroup,
  BModal,
  BTabs,
  BTab,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, email, phone, national_id,
} from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { debounce } from '@/utils/helper'

export default {
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BForm,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BAvatar,
    BInputGroup,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    vSelect,
    BLink,
    BSpinner,
    BPagination,
    BFormInput,
    BModal,
    BTabs,
    BTab,
    BListGroup,
    BListGroupItem,
    FeatherIcon,
  },
  computed: {
    ...mapGetters({
      items: 'employees/employees',
      load: 'employees/load',
      roles: 'roles/items',
      unlinkedUsers: 'users/unlinkedUsers',
      linkUserLoading: 'users/unlinkedUsersLoading',
    }),

  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  watch: {
    'filter.search': function (newVal) {
      newVal == '' ? this.filter.search = null : this.filter.search = newVal
      this.updateQueryParams()
      this.$store.dispatch('employees/listEmployees', { query: { ...this.filter, page: 1 } })
    },
    'filter.type': function (newVal) {
      this.updateQueryParams()
      this.$store.dispatch('employees/listEmployees', { query: { ...this.filter, page: 1 } })
    },
  },
  data() {
    return {
      type_data: [
        { value: 'inner employee', label: 'موظف داخلي' },
        { value: 'outer employee', label: 'موظف خارجي' },
      ],
      addUserModal: false,
      userModalTabIndex: 0,
      addUserForm: {
        email: '',
        role_id: null,
        password: '',
        password_confirmation: '',

      },

      selectedEmployee: null,
      // Link to existing user data
      userSearchQuery: '',
      selectedUserID: null,
      linkUserError: null,
      hasSearched: false,
      searchTimeout: null,
      checkboxStatus: {},
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      checked: true,
      addNewUserModal: false,
      filter: {
        school_id: null,
        type: 'inner employee',
        status: null,
        search: null,
      },
      status_data: [
        'active',
        'inactive',
        'suspended',
      ],
      fields: [
        { key: 'show_details', label: '' },
        // { key: "avatar", label: "Avatar" },
        { key: 'full_name', label: 'الاسم', sortable: true },
        { key: 'phones[0].phone_number', label: 'الهاتف' },
        { key: 'national_id_details.gender', label: 'الجنس' },
        { key: 'national_id', label: 'الرقم القومي' },
        { key: 'status', label: 'الحالة' },
        { key: 'wallet_balance', label: 'رصيد المحفظة' },
        'Actions',
      ],

    }
  },
  mounted() {
    this.init()
  },
  methods: {
    openAddUserModal(item) {
      this.selectedEmployee = item
      this.addUserForm = {
        email: null,
        name: item.full_name,
        address: item.address,
        national_id: item.national_id,
        phone: item.phones ? item.phones[0].phone_number : null,
        employee_id: item.id,
        roles: [],
        password: '',
        password_confirmation: '',
      }
      this.userModalTabIndex = 0
      this.addUserModal = true
    },
    resetModal() {
      this.userModalTabIndex = 0
      this.userSearchQuery = ''
      this.selectedUserID = null
      this.linkUserError = null
      this.hasSearched = false
      // Reset unlinked users in store
      this.$store.commit('users/SET_UNLINKED_USERS', [])
      this.$store.commit('users/SET_UNLINKED_USERS_PAGINATION', {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1,
      })
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = null
      }
    },
    onUserSearchInput(search, loading) {
      if (search) {
        this.userSearchQuery = search
        const query = search ? { search } : {}
        this.$store.dispatch('users/searchUnlinkedUsers', { query }).finally(() => {
          if (loading) loading(false)
        })
      }
    },
    // async searchUnlinkedUsers(search) {
    //   if(search){
    //     this.userSearchQuery = search;
    //     const query = search ? { search } : {}
    //     this.$store.dispatch('users/searchUnlinkedUsers', { query }).finally(() => {
    //       if (loading) loading(false)
    //     })
    //   }
    // },
    async linkEmployeeToUser() {
      const userId = this.selectedUserID

      this.$store.dispatch('users/linkEmployee', {
        userId,
        employeeId: this.selectedEmployee.id,
      }).then(res => {
        this.$swal({
          icon: 'success',
          title: `<h4>${res.message}</h4>`,
          showConfirmButton: true,
          confirmButtonColor: '#06284D',
          allowOutsideClick: true,
        })
      }).catch(error => {
        this.$swal({
          icon: 'error',
          title: `<h4>${error.response.data.message || 'حدث خطأ'}</h4>`,
          showConfirmButton: true,
          confirmButtonColor: '#06284D',
          allowOutsideClick: true,
        })
      }).finally(() => {
        this.linkUserLoading = false
      })
    },

    submitAddUser() {
      this.$refs.addUserForm.validate().then(success => {
        if (success) {
          const payload = { query: this.addUserForm }

          this.$store.dispatch('users/store', payload).then(res => {
            this.addUserModal = false

            this.$swal({
              icon: 'success',
              title: `<h4>${res.message}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#06284D',
              allowOutsideClick: true,
            })
          }).catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: `<h4>${error.response.data.message}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#06284D',
                allowOutsideClick: true,
              })
            }
          })
        }
      })
    },
    deleteEmployee(id) {
      const _this = this
      this.$swal({
        icon: 'warning',
        title: 'هل انت متأكد من مسح  بيانات الموظف',
        showCancelButton: true,
        confirmButtonText: 'نعم, متأكد!',
        cancelButtonText: 'الغاء',
        confirmButtonColor: '#06284D',
      }).then(isConfirm => {
        if (isConfirm.isConfirmed) {
          _this.$store.dispatch('employees/delete', id).then(_ => {
            _this.refreshData()
          })
        } else {

        }
      }).finally(_ => {

      })
    },
    addNewEmp(id) {
      this.$router.push({ name: 'student_analytics', params: { id } })
      this.$router.push({ name: 'add_employee' })
    },
    emptyUser() {
      this.user = {
        name: '',
        email: '',
        phone: '',
        national_id: '',
        password: '',
        address: '',
        status: 'active',
      }
    },

    onPageChange(page) {
      this.$store.dispatch('employees/listEmployees', { query: { ...this.filter, page } })
    },
    refreshData() {
      this.$store.dispatch('employees/listEmployees', { query: { ...this.filter, page: this.items.current_page } })
    },

    updateQueryParams() {
      const queryParams = {
        type_id: this.filter.type_id || null,
        status: this.filter.status || null,
        search: this.filter.search || null,
      }
      this.$router.replace({ query: queryParams }).catch(() => {
        // Ignore redundant navigation errors
      })
    },
    init() {
      this.$store.dispatch('employees/listEmployees', { query: { ...this.filter, page: 1 } }).then(res => {
      })
      this.$store.dispatch('roles/listRoles')
    },
    assignRole(item) {
      this.$router.push({ name: 'assign_role', params: { id: item.id } })
    },
    formatCurrency(amount, currency = 'EGP') {
      if (!amount && amount !== 0) return '0.00'
      return new Intl.NumberFormat('ar-EG', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount)
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
